// extracted by mini-css-extract-plugin
export var section_wrapper = "intro-tile-module--section_wrapper--2IUkP";
export var photo_desktop = "intro-tile-module--photo_desktop--2a_aU";
export var img = "intro-tile-module--img--3Fujo";
export var caption = "intro-tile-module--caption--2U7E4";
export var content = "intro-tile-module--content--iFi9S";
export var photo_mobile = "intro-tile-module--photo_mobile--3QMs4";
export var text = "intro-tile-module--text--STLcJ";
export var cta = "intro-tile-module--cta--1iVbe";